module.exports = __webpack_public_path__ + "img/porch-swing.b6cad191.jpg";